export function validationCUIT(cuit: string): { valid: boolean; type: string | null } {
  if (cuit.length !== 11) {
    return { valid: false, type: null };
  }

  const multipliers = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  const checkDigit = parseInt(cuit[10], 10);

  for (let i = 0; i < 10; i++) {
    sum += parseInt(cuit[i], 10) * multipliers[i];
  }

  let calculatedCheckDigit = 11 - (sum % 11);
  if (calculatedCheckDigit === 11) calculatedCheckDigit = 0;
  if (calculatedCheckDigit === 10) calculatedCheckDigit = 9;

  if (checkDigit !== calculatedCheckDigit) {
    return { valid: false, type: null };
  }

  // Determinar el tipo de persona según el prefijo
  const prefix = cuit.slice(0, 2);
  let type: string | null = null;

  if (["20", "23", "27"].includes(prefix)) {
    type = "Persona Física";
  } else if (["30", "33"].includes(prefix)) {
    type = "Persona Jurídica";
  } else {
    type = "Tipo desconocido";
  }

  return { valid: true, type };
}
